import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewCardsReport = () => { 
    return useQuery({ 
        queryKey: ['viewCardsReport'], 
        queryFn: async () => { 
            const res = await api.get('/reports/card-counts', {
            }); 
            return res.data; 
        }
     });
};  